/* jshint esversion: 6 */

import Vue from 'vue';
import Router from 'vue-router';
import AppHeader from './layout/AppHeader';
import AppFooter from './layout/AppFooter';
import Homepage from './views/Homepage.vue';
import Portfolio from './views/Portfolio.vue';
import Connect from './views/Connect.vue';
import Privacy from './views/Privacy.vue';

Vue.use(Router);

export default new Router({
	linkExactActiveClass: 'active',
	mode: 'history',
	routes: [
		{
			path: '/',
			components: {
				header: AppHeader,
				default: Homepage,
				footer: AppFooter
			}
		},
		{
			path: '/portfolio',
			components: {
				header: AppHeader,
				default: Portfolio,
				footer: AppFooter
			}
		},
		{
			path: '/contact',
			components: {
				header: AppHeader,
				default: Connect,
				footer: AppFooter
			}
		},
		{
			path: '/privacy',
			components: {
				header: AppHeader,
				default: Privacy,
				footer: AppFooter
			}
		}
	],
	scrollBehavior: (to) => {
		if (to.hash) {
			return {
				selector: to.hash
			};
		} else {
			return {
				x: 0,
				y: 0
			};
		}
	}
});
